import { SidebarHeader } from "@/components/layout/Sidebar/SidebarHeader";
import { useBrandingAdsChecker } from "@/hooks/useBrandingAdsChecker";
import { useHiddenScrollingClass } from "@/hooks/useHiddenScrollingClass";
import { SidebarProps } from "@/types/layout";
import autoAnimate from "@formkit/auto-animate";
import React, { useEffect, useRef, useState } from "react";
import { useClickedOutside } from "@/hooks/useClickedOutside";

export const PostSidebar: React.FC<SidebarProps> = ({ openedBurgerMenu, setOpenedMenu, post }) => {
  const [openedMenu, setOpenedBurgerMenu] = useState<boolean>(openedBurgerMenu);
  const [, setShowScrollbar] = useState<boolean>(false);
  const { shouldHideHeader } = useHiddenScrollingClass();
  const { displayBranding } = useBrandingAdsChecker();

  const sidebarRef = useClickedOutside(() => {
    setOpenedBurgerMenu(false);
  });

  useEffect(() => {
    setOpenedBurgerMenu(openedBurgerMenu);
  }, [openedBurgerMenu]);

  const toggleMenu = (value: boolean) => {
    setOpenedMenu?.(value);
    setOpenedBurgerMenu(value);
  };

  const parent = useRef(null);

  useEffect(() => {
    parent.current &&
      autoAnimate(parent.current, {
        duration: 120,
        easing: "ease-in-out",
        disrespectUserMotionPreference: false,
      });
  }, [parent]);

  return (
    <>
      {displayBranding ? (
        <div
          className={`sticky z-50 bg-white transition-all duration-500 ease-in-out dark:bg-dark ${
            shouldHideHeader ? "-top-[69px]" : "top-0"
          }`}
          ref={sidebarRef}
        >
          <SidebarHeader
            openedBurgerMenu={openedMenu}
            setOpenedMenu={toggleMenu}
            postDetailSidebar={true}
            postDetailControls={true}
            post={post}
          />
        </div>
      ) : (
        <aside
          className={`fixed top-[3.5px] z-50 w-screen lg:z-10`}
          onMouseEnter={() => setShowScrollbar(true)}
          onMouseLeave={() => setShowScrollbar(false)}
          ref={sidebarRef}
        >
          <div ref={parent} className="relative lg:-mt-[1px]">
            <div
              className={`relative bg-white transition-all duration-500 ease-in-out dark:bg-dark ${
                shouldHideHeader ? "-top-[69px]" : "top-0"
              }`}
            >
              <SidebarHeader
                openedBurgerMenu={openedMenu}
                setOpenedMenu={toggleMenu}
                postDetailSidebar={true}
                postDetailControls={true}
                post={post}
              />
            </div>
          </div>
        </aside>
      )}
    </>
  );
};
